module.exports = __webpack_public_path__ + "img/timer-solid.173d13d9.svg";